import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { ColorSearchAutocomplete } from "components/input/colorSearchAutocomplete/ColorSearchAutocomplete";
import type { FilterEntry, FilterType } from "hooks/filters";
import { type Dispatch, useMemo } from "react";

export interface ApplicationFilterProps {
  value?: Array<AutocompleteData>;
  onChange?: Dispatch<Array<AutocompleteData>>;
  industry?: Array<AutocompleteData>;
  applicationClass?: Array<AutocompleteData>;
  isDisabled?: boolean;
  t: (key: string) => string;
}

export const ApplicationFilter = ({
  value = [],
  onChange,
  industry,
  applicationClass,
  isDisabled,
  t,
}: ApplicationFilterProps) => {
  const filters: Array<FilterEntry> = useMemo(
    () =>
      [
        {
          type: "industry" as FilterType,
          value: industry,
        },
        {
          type: "applicationClass" as FilterType,
          value: applicationClass,
        },
      ].filter((e) => e.value !== undefined && e.value.length > 0),
    [industry, applicationClass],
  );

  return (
    <ColorSearchAutocomplete
      label={t("filter_application")}
      example={t("filter_application_exmple")}
      type="application"
      value={value}
      filters={filters}
      limit={500}
      onChange={onChange}
      isDisabled={isDisabled}
    />
  );
};
